export const CLASSIFICATION_COLORS = {
  UNCLASSIFIED: 'default',
  SUPERVISED_AREA: 'warning',
  CONTROLLED_AREA: 'error',
};